import { useRightPanel } from '@/components/layout/workspace/rightPanelContext';
import type { MessageActions } from '@/lib/conversation';
import { ENTITIES, HOME } from './model';
import { PEOPLE } from './personModel';

export function useSampleMessageActions(): MessageActions {
  const panel = useRightPanel();
  return {
    entities: ENTITIES,
    people: PEOPLE,
    onEntityOpen: (entity, trigger) =>
      panel.open(
        {
          id: entity.id,
          title: entity.name,
          path: HOME + '/entity/' + entity.id,
          eyebrow: entity.kind === 'user' ? 'Участник образца' : 'Канал образца',
        },
        trigger,
      ),
    onAttachmentOpen: (file, trigger) =>
      panel.open(
        { id: file.id, title: file.name, path: HOME + '/file/' + file.id, eyebrow: 'Вложение' },
        trigger,
      ),
  };
}
